import { render, staticRenderFns } from "./EmployeeDataInquiry.vue?vue&type=template&id=5901af38&scoped=true&"
import script from "./EmployeeDataInquiry.vue?vue&type=script&lang=js&"
export * from "./EmployeeDataInquiry.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDataInquiry.vue?vue&type=style&index=0&id=5901af38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901af38",
  null
  
)

export default component.exports